module.exports = __webpack_public_path__ + "aa.no2.7c6b0dfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/aa.no2.jpg
// module id = B6Pq
// module chunks = 0